module.exports = __webpack_public_path__ + "img/icon-alert-circle.5df1854e.svg";